import React from "react";
import Grid from "~components/Grid";
import ResponsiveImage from "~components/ResponsiveImage";
import Button from "~components/Button";
import styles from "./index.module.scss";
import PageHTMLElement from "~components/PageHTMLElement";
import cn from "classnames";

const Details = ({ items }) => {
  return (
    <div className={styles.details}>
      {items.map((item, index) => (
        <p dangerouslySetInnerHTML={{ __html: item }} key={index} />
      ))}
    </div>
  );
};

const AppDownload = (props) => {
  const pageData = props.pageData?.appDownload;
  if (!pageData) {
    return null;
  }
  return (
    <div className={styles.appDownload} id="onvo-app-download">
      <Grid className={styles.gridSectioon}>
        <div
          className={cn(styles.gridContainer, "grid-col-md-6 grid-col-lg-10")}
        >
          <div className={styles.leftContainer}>
            <ResponsiveImage src={pageData.logo} className={styles.logo} />
            <PageHTMLElement {...pageData.title} className={styles.title} />
            <div className={styles.qrCodeContainer}>
              <ResponsiveImage
                src={pageData.qrCode.src}
                className={styles.qrCode}
              />

              <div className={styles.detailContainer}>
                <PageHTMLElement
                  {...pageData.disclaimer.title}
                  className={styles.title}
                />
                <Details items={pageData.disclaimer.details} />
              </div>
            </div>
          </div>

          <Button
            {...pageData.downloadButton}
            className={styles.downloadButton}
          />

          <ResponsiveImage {...pageData.phoneImg} className={styles.phoneImg} />
          <Details items={pageData.disclaimer.details} />
        </div>
      </Grid>
    </div>
  );
};

export default AppDownload;
